import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { D7TriggerQaScenario } from "./d7-trigger-qa-scenario";

export type { D7TriggerQaScenario } from "./d7-trigger-qa-scenario";

export const devOverridesEnabled =
  import.meta.env.DEV ||
  import.meta.env.VITE_STYTCH_PUBLIC_ENV !== "production";

export type MagicMomentDayOverride = "day1" | "day2" | null;

export type NewMentorUiOverride = "default" | "new" | "old";

export type MentorProfileOverride = "default" | "on" | "off";

export type MentorStoriesOverride = "default" | "on" | "off";

export type UserRecordsV2Override = "default" | "on" | "off";

interface DevOverridesStore {
  magicMomentDay: MagicMomentDayOverride;
  forceDay2Modal: boolean;
  forceAtRiskMomentum: boolean;
  newMentorUiOverride: NewMentorUiOverride;
  mentorProfileOverride: MentorProfileOverride;
  mentorStoriesOverride: MentorStoriesOverride;
  mentorProfileMockData: boolean;
  userRecordsV2Override: UserRecordsV2Override;
  d7TriggerQaScenario: D7TriggerQaScenario | null;
  hidePhiPii: boolean;
  setMagicMomentDay: (value: MagicMomentDayOverride) => void;
  setForceDay2Modal: (value: boolean) => void;
  setForceAtRiskMomentum: (value: boolean) => void;
  setNewMentorUiOverride: (value: NewMentorUiOverride) => void;
  setMentorProfileOverride: (value: MentorProfileOverride) => void;
  setMentorStoriesOverride: (value: MentorStoriesOverride) => void;
  setMentorProfileMockData: (value: boolean) => void;
  setUserRecordsV2Override: (value: UserRecordsV2Override) => void;
  setD7TriggerQaScenario: (value: D7TriggerQaScenario | null) => void;
  setHidePhiPii: (value: boolean) => void;
  reset: () => void;
}

export const useDevOverridesStore = create(
  persist<DevOverridesStore>(
    (set) => ({
      magicMomentDay: null,
      forceDay2Modal: false,
      forceAtRiskMomentum: false,
      newMentorUiOverride: "default",
      mentorProfileOverride: "default",
      mentorStoriesOverride: "default",
      mentorProfileMockData: false,
      userRecordsV2Override: "default",
      d7TriggerQaScenario: null,
      hidePhiPii: false,
      setMagicMomentDay: (value) => set({ magicMomentDay: value }),
      setForceDay2Modal: (value) => set({ forceDay2Modal: value }),
      setForceAtRiskMomentum: (value) =>
        set({ forceAtRiskMomentum: value }),
      setNewMentorUiOverride: (value) => set({ newMentorUiOverride: value }),
      setMentorProfileOverride: (value) =>
        set({ mentorProfileOverride: value }),
      setMentorStoriesOverride: (value) =>
        set({ mentorStoriesOverride: value }),
      setMentorProfileMockData: (value) =>
        set({ mentorProfileMockData: value }),
      setUserRecordsV2Override: (value) =>
        set({ userRecordsV2Override: value }),
      setD7TriggerQaScenario: (value) => set({ d7TriggerQaScenario: value }),
      setHidePhiPii: (value) => set({ hidePhiPii: value }),
      reset: () =>
        set({
          magicMomentDay: null,
          forceDay2Modal: false,
          forceAtRiskMomentum: false,
          newMentorUiOverride: "default",
          mentorProfileOverride: "default",
          mentorStoriesOverride: "default",
          mentorProfileMockData: false,
          userRecordsV2Override: "default",
          d7TriggerQaScenario: null,
          hidePhiPii: false,
        }),
    }),
    {
      name: "dev-overrides",
    },
  ),
);
